// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af205ec6","821":"f35561ec"}[chunkId] + ".chunk.js";
};